import { createContext } from 'react';

export type SnackbarSeverity = 'success' | 'error' | 'warning' | 'info' | 'loading';

export interface SnackbarContextType {
  showSnackbar: (message: string, severity?: SnackbarSeverity, duration?: number) => void;
  showSuccess: (message: string, duration?: number) => void;
  showError: (message: string, duration?: number) => void;
  showWarning: (message: string, duration?: number) => void;
  showInfo: (message: string, duration?: number) => void;
  showLoading: (message: string) => void;
}

export const SnackbarContext = createContext<SnackbarContextType | undefined>(undefined);

export const DEFAULT_DURATION = 6000;
